import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-operation-executing',
  templateUrl: './operation-executing.component.html',
  styleUrls: ['./operation-executing.component.css']
})
export class OperationExecutingComponent implements OnInit {
  dialog:any;

  constructor(
    private dialogRef: MatDialogRef<OperationExecutingComponent>,
    @Inject(MAT_DIALOG_DATA) data ) {
    this.dialog = data;    
   }

  ngOnInit() {
    console.log('OperationExecutingComponent', this.dialog);
  }

}
